import { Switch, Route, Redirect, NavLink, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./App.css";
import api from "./api";
import Login from "./component/Login";
import Send from "./component/Send";
import History from "./component/History";
import Stats from "./component/Stats";
import Templates from "./component/Templates";
import Schedules from "./component/Schedules";

function Nav({ user }) {
  const history = useHistory();

  const logout = async () => {
    await api.get("/logout").catch(() => {});
    window.location.href = "/";
  };

  return (
    <nav className="nav">
      <div className="brand" onClick={() => history.push("/main")}>
        <b>TOBE</b> <span>문자발송</span>
      </div>
      <NavLink to="/main" className="nav-link" activeClassName="on">발송</NavLink>
      <NavLink to="/history" className="nav-link" activeClassName="on">전송내역</NavLink>
      <NavLink to="/schedules" className="nav-link" activeClassName="on">예약함</NavLink>
      <NavLink to="/templates" className="nav-link" activeClassName="on">템플릿</NavLink>
      <NavLink to="/stats" className="nav-link" activeClassName="on">통계</NavLink>
      <div className="nav-right">
        <span className="who">{user}</span>
        <button className="btn ghost sm" onClick={logout}>로그아웃</button>
      </div>
    </nav>
  );
}

function App() {
  const [auth, setAuth] = useState({ checked: false, ok: false, user: "" });

  useEffect(() => {
    api
      .get("/abc")
      .then((res) => {
        const ok = !!res.data.status;
        setAuth({ checked: true, ok, user: res.data.userId || "" });
        if (ok && window.location.pathname === "/") window.location.href = "/main";
        if (!ok && window.location.pathname !== "/") window.location.href = "/";
      })
      .catch(() => setAuth({ checked: true, ok: false, user: "" }));
  }, []);

  if (!auth.checked) return <div className="booting">불러오는 중…</div>;

  return (
    <div className="App">
      {auth.ok && <Nav user={auth.user} />}
      <div className={auth.ok ? "page" : ""}>
        <Switch>
          <Route path="/" exact><Login /></Route>
          <Route path="/main"><Send /></Route>
          <Route path="/history"><History /></Route>
          <Route path="/schedules"><Schedules /></Route>
          <Route path="/templates"><Templates /></Route>
          <Route path="/stats"><Stats /></Route>
          {/* 옛 주소(/SendHistory, /template, /Excel) 즐겨찾기 대비 */}
          <Route path="/SendHistory"><Redirect to="/history" /></Route>
          <Route path="*"><Redirect to={auth.ok ? "/main" : "/"} /></Route>
        </Switch>
      </div>
    </div>
  );
}

export default App;
